import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Form,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  ModalHeader,
  Button,
  Label,
  FormFeedback,
  Row,
} from "reactstrap"
import * as Yup from "yup"
import DeleteModel from "common/deleteModel/deleteModel"
import toast from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import ErrorModel from "common/errorModel/errorModel"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"
import { useFormik } from "formik"
import { UnBillsType } from "_mock/Static_data"
import OccasionsTable from "./OccasionsTable"
import { exportDataExcel } from "components/Common/ExportData"

function Occasions() {
  document.title = `Occations | Raja Rani Couture`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()
  // useStates
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState("")
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)
  const [formSumitLoading, setformSumitLoading] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [occasionId, setOccasionId] = useState(0)


  // occasion list api
  const occasionApi = () => {
    setScreenLoad(true)
    setIsLoading(true)
    getApi("Common/occasion/list").then(({ data, status }) => {
      if (status === 200) {
        setIsLoading(false)
        setTableData(data)
        setTotalRecords(data.length)
      } else {
        setIsLoading(false)
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setScreenLoad(false)
    })
  }

  // occasion list api useEffect
  useEffect(() => {
    occasionApi()
  }, [])

  // toggle handlers
  const toggle = () => {

    setModal(!modal)
    validation.handleReset()
  }

  // cancle handler
  const handleCancle = () => {
    toggle()
  }

  // Delete occasion handler
  const handleDelete = occasionId => {
    setScreenLoad(true)
    if (occasionId) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this occasion permanently? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          deleteApi(`Common/occasion/delete?Id=${occasionId}`).then(
            ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== occasionId ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("successfully deleted", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                ErrorModel.errormodel({
                  title: "Verify Occasion",
                  text: data,
                })
              }
              setScreenLoad(false)
            }
          )
        } else {
          setScreenLoad(false)
        }
      })
    }
  }

  const handleEditOccasion = occasiondata => {
    if (occasiondata) {
      setOccasionId(occasiondata.Id)
      setIsEdit(true)
      setModal(!modal)
      setEditData(occasiondata)
    }
  }

  // Create occasion handler
  const handleOccasionClick = () => {
    setIsEdit(false)
    toggle()
  }

  // Categories Validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      Name: isEdit ? editData?.Name : "",
    },
    validationSchema: Yup.object({
      Name: Yup.string().required("The name is required"),
    }),
    onSubmit: values => {
      setformSumitLoading(true)
      if (values) {
        postApi("Common/occasion/addedit", {
          id: isEdit ? parseInt(occasionId) : 0,
          name: values.Name,
        }).then(({ data, status }) => {
          setformSumitLoading(false)
          if (status == 400) {
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
          } else {
            toast.success(isEdit ? "successfully updated" : "successfully created", {
              style: {
                fontSize: "15px",
              },
            })
            toggle()
            occasionApi()
            validation.handleReset()
          }
        })
      }
    },
  })

  // Occasion table header & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Occasion",
        accessor: "Name",
      },

      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "6%",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-edit btn-edit"
                  id={`edittooltip${row.original.Id}`}
                  onClick={() => handleEditOccasion(row.original)}
                ></i>
                <span className="mytext">Edit</span>
              </li>

              <li className="mytooltip">
                <i
                  id={`deletetooltip${row.original.Id}`}
                  className="fs-6 fas fa-trash-alt btn-delete"
                  onClick={() => handleDelete(row.original.Id)}
                ></i>
                <span className="mytext">Delete</span>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )


  function writeDataToExcel() {
    setIsLoading(true)
    let header = ["Name"];
    const mainTitle = "Occasions";
    const widthObj = [{
      Key: "A",
      Value: 30,
    },
    ]
    const extention = "Occasions.xlsx"
    let excelSheetData = []
    for (let index = 0; index < tableData.length; index++) {
      let dataObj = {
        Name: tableData[index].Name,
      }
      excelSheetData.push(dataObj)
    }
    var fields = Object.keys(excelSheetData[0]);
    var sheetData = excelSheetData.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName];
      });
    });
    setIsLoading(false)
    sheetData.unshift(header);
    exportDataExcel(sheetData, mainTitle, widthObj, extention)
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].title}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
        />
        <Card>
          <CardBody>
            <OccasionsTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              handleOccasionClick={handleOccasionClick}
              customPageSize={10}
              className="custom-header-css"
              isLoading={isLoading}
              TotalRecords={totalRecords}
              writeDataToExcel={writeDataToExcel}
            />

            <Modal
              isOpen={modal}
              toggle={toggle}
              centered={true}
              size="small"
              style={{ width: !isMobile ? "350px" : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                  {isEdit ? "Update Occasion" : "Create Occasion"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      validation.handleReset()
                      return false
                    }}
                  >
                    <FormGroup className="mb-2">
                      <Label htmlFor="validationCustom03" className="required">
                        Name
                      </Label>
                      <Input
                        name="Name"
                        placeholder="occasion Name"
                        type="text"
                        className="form-control-sm"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.Name || ""}
                        invalid={
                          validation.touched.Name && validation.errors.Name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.Name && validation.errors.Name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.Name}
                        </FormFeedback>
                      ) : null}
                    </FormGroup>
                    <div className="text-end">
                      {isEdit ? (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm"
                          onClick={handleCancle}
                        >
                          Cancle
                        </Button>
                      ) : (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          type="reset"
                        >
                          Reset
                        </Button>
                      )}
                      <>
                        {formSumitLoading ? (
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                          >
                            <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                            Loading
                          </button>
                        ) : (
                          <Button
                            color="primary"
                            className="btn btn-primary btn-sm "
                            type="submit"
                          >
                            Submit
                          </Button>
                        )}
                      </>
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}
Occasions.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Occasions